import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "static-hero" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "static-body bg-gondola" }
const _hoisted_4 = {
  class: "container mw-1356",
  style: {"max-width":"900px"}
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "about-stats"
}
const _hoisted_7 = { class: "about-stat-value" }
const _hoisted_8 = { class: "about-stat-label" }
const _hoisted_9 = {
  key: 2,
  class: "about-features"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarTwo = _resolveComponent("NavbarTwo")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NavbarTwo),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "top-title" }, "ABOUT US", -1)),
        _createElementVNode("h1", null, _toDisplayString(_ctx.c.heading || 'About VivoTv'), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.c.subheading || 'Your premium IPTV destination'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.c.body)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "about-body",
              innerHTML: _ctx.c.body
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.stats.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, (s, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "about-stat"
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(s.value), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(s.label), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.features.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (f, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "about-feature"
                }, [
                  _cache[1] || (_cache[1] = _createElementVNode("i", { class: "ti ti-circle-check" }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(f), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_MainFooter),
    _createVNode(_component_CopyRight)
  ]))
}